(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draws-redux/assets/javascripts/services/get-related-draws.js') >= 0) return;  svs.modules.push('/components/sport/draws-redux/assets/javascripts/services/get-related-draws.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
let products;
let normalizeDrawsLite;
let normalizeFundsLite;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  products = trinidad.components.require('utils', 'products');
  normalizeDrawsLite = require('../normalize-draws-lite.es6');
  normalizeFundsLite = require('../normalize-funds-lite.es6');
} else {
  products = svs.utils.products;
  normalizeDrawsLite = svs.components.sport.drawsRedux.normalizeDrawsLite;
  normalizeFundsLite = svs.components.sport.drawsRedux.normalizeFundsLite;
}
const fetchRelatedDraws = fetcher => req => async _ref => {
  let relatedProductId = _ref.relatedProductId,
    productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    type = _ref.type;
  const itsProductId = products.getSpecificDrawName(relatedProductId);
  const params = new URLSearchParams([['ctx', "draw_".concat(itsProductId)], ['andfilter', ['payload.draw.drawState;Open'].join(',')], ['includes', ['payload.draw.regCloseTime', 'payload.draw.drawComment', 'payload.draw.drawNumber'].join(',')], ['sort', 'payload.draw.regCloseTime']]);
  const jackpotPath = '/draw/1/jackpots';
  const relatedDrawPath = "/search/1/query?".concat(params);
  const _await$fetcher = await fetcher(relatedDrawPath, jackpotPath, req),
    _await$fetcher2 = _slicedToArray(_await$fetcher, 2),
    drawData = _await$fetcher2[0],
    jackpotData = _await$fetcher2[1];
  const Funds = normalizeFundsLite(drawData.result, jackpotData.jackpots ? jackpotData.jackpots : [], relatedProductId);
  const normalizedDraws = normalizeDrawsLite(drawData.result, relatedProductId, productId, drawNumber, type);
  return _objectSpread(_objectSpread({}, normalizedDraws), {}, {
    Funds
  });
};
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  const fetchJackpots = async (jackpotPath, req) => {
    try {
      const jackpotResponse = await trinidad.jupiter.callAsync({
        method: 'GET',
        path: jackpotPath,
        req
      });
      return jackpotResponse;
    } catch (_unused) {
      return [];
    }
  };
  const fetchDraws = async (drawsPath, req) => {
    const drawResponse = await trinidad.jupiter.callAsync({
      method: 'GET',
      path: drawsPath,
      req
    });
    return drawResponse;
  };
  const fetcher = async (drawPath, jackpotPath, req) => {
    const _await$Promise$all = await Promise.all([fetchDraws(drawPath, req), fetchJackpots(jackpotPath, req)]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
      draws = _await$Promise$all2[0],
      jackpots = _await$Promise$all2[1];
    return [draws, jackpots];
  };
  module.exports = fetchRelatedDraws(fetcher);
} else {
  const jupiterFetch = svs.core.jupiterFetch;
  const fetcher = async (drawPath, jackpotPath) => {
    const _await$Promise$all3 = await Promise.all([jupiterFetch.fetch(drawPath, {
        method: 'GET'
      }), jupiterFetch.fetch(jackpotPath, {
        method: 'GET'
      })]),
      _await$Promise$all4 = _slicedToArray(_await$Promise$all3, 2),
      drawResponse = _await$Promise$all4[0],
      jackpotResponse = _await$Promise$all4[1];
    const drawData = await drawResponse.json();
    const jackpotData = await jackpotResponse.json();
    if (!drawResponse.ok) {
      throw drawData;
    }
    return [drawData, jackpotData];
  };
  setGlobal('svs.components.sport.drawsRedux.fetchRelatedDraws', fetchRelatedDraws(fetcher)());
}

 })(window);